<div class="activation-toolbar">
  <mat-form-field appearance="fill" class="activation-filter-field">
    <mat-label>Filter activations</mat-label>
    <input matInput id="filterActivations" [(ngModel)]="criteria" placeholder="Hostname, code, or comment" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="activation-toolbar-actions">
    <div class="activation-surrender-summary" *ngIf="showSurrender">
      <strong>Surrenders Remaining:</strong>
      <span id="activation-surrenders-remaining">{{ returnsRemaining }}</span>
    </div>
    <button mat-raised-button color="primary" id="export-activations-button" type="button" (click)="exportActivations()"
      *ngIf="contractId != null && !showRenew" [disabled]="exportDisabled()">
      <mat-spinner *ngIf="exporting" diameter="20" mode="indeterminate"></mat-spinner>
      {{ exporting ? 'Exporting' : 'Export activations' }}
    </button>
    <button mat-flat-button color="primary" id="surrender-selected-button" type="button" *ngIf="showSurrender" (click)="triggerSurrender()"
      [disabled]="selectedCount == 0">
      Surrender
    </button>
    <button mat-flat-button color="primary" id="renew-activations-button" type="button" *ngIf="showRenew" (click)="confirmRenewal()"
      [disabled]="renewDisabled()">
      <mat-spinner *ngIf="renewing" diameter="20" mode="indeterminate"></mat-spinner>
      {{ renewing ? 'Renewing' : 'Renew License' }}<span *ngIf="!renewing && selectedCount > 1">s</span>
    </button>
  </div>
</div>

<div class="activation-type-filters">
  <mat-checkbox *ngIf="hasActivationType('physical')" id="activation-type-physical" [ngModel]="showPhysical"
    (ngModelChange)="setTypeVisibility('physical', $event)">Physical ({{ getActivationTypeCount('physical')
    }})</mat-checkbox>
  <mat-checkbox *ngIf="hasActivationType('virtual')" id="activation-type-virtual" [ngModel]="showVirtual"
    (ngModelChange)="setTypeVisibility('virtual', $event)">Virtual ({{ getActivationTypeCount('virtual')
    }})</mat-checkbox>
  <mat-checkbox *ngIf="hasActivationType('desktop')" id="activation-type-desktop" [ngModel]="showDesktop"
    (ngModelChange)="setTypeVisibility('desktop', $event)">Desktop ({{ getActivationTypeCount('desktop')
    }})</mat-checkbox>
  <mat-checkbox *ngIf="hasActivationType('token')" id="activation-type-token" [ngModel]="showTokens"
    (ngModelChange)="setTypeVisibility('token', $event)">Tokens ({{ getActivationTypeCount('token') }})</mat-checkbox>
</div>

<div class="table-loading-state" *ngIf="loading">
  <mat-spinner diameter="56"></mat-spinner>
</div>

<div class="fh-table table-responsive" *ngIf="!showRenew && !loading">
  <table class="table table-striped table-hover activation-table">
    <colgroup>
      <col class="col-hostname">
      <col class="col-type">
      <col *ngIf="showActivationCodeColumn" class="col-code">
      <col *ngIf="showComments" class="col-comment">
      <col class="col-date">
      <col *ngIf="rental" class="col-date">
      <col *ngIf="showActionColumn" class="col-actions">
      <col *ngIf="showSurrender" class="col-checkbox">
    </colgroup>
    <thead>
      <tr>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activations-hostname" (click)="sortBy('hostname')">Hostname
            <mat-icon>{{ getSortIcon('hostname') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activations-type" (click)="sortBy('type')">Type <mat-icon>{{
              getSortIcon('type') }}</mat-icon></button></th>
        <th *ngIf="showActivationCodeColumn">License Key</th>
        <th *ngIf="showComments"><button mat-button type="button" class="table-sort-button" id="sort-activations-comment"
            (click)="sortBy('comment')">Comment
            <mat-icon>{{ getSortIcon('comment') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activations-obtained" (click)="sortBy('obtained')">Obtained
            <mat-icon>{{ getSortIcon('obtained') }}</mat-icon></button></th>
        <th *ngIf="rental"><button mat-button type="button" class="table-sort-button" id="sort-activations-expiry"
            (click)="sortBy('expiry')">Expiry <mat-icon>{{ getSortIcon('expiry') }}</mat-icon></button></th>
        <th *ngIf="showActionColumn" class="table-actions-header"></th>
        <th *ngIf="showSurrender" class="table-actions-header">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="displayedActivations.length == 0">
        <td [attr.colspan]="activationColumnCount" class="table-empty-state">
          {{ showSurrender ? 'You have no activations available to return.' : 'You have not performed any activations.'
          }}
        </td>
      </tr>
      <tr *ngFor="let act of displayedActivations; let i = index">
        <td>
          <span class="ellipsis-cell hostname-cell" [matTooltip]="act.hostname || ''"
            [matTooltipDisabled]="!shouldShowTooltip(act.hostname, 28)">{{ act.hostname }}</span>
        </td>
        <td class="nowrap-cell text-capitalize">
          <span *ngIf="act.activationType != 'TOKEN'">{{ getActivationTypeLabel(act) }}</span>
          <span *ngIf="act.activationType == 'TOKEN'">{{ act.count }} token<span *ngIf=" act.count == 0||act.count > 1">s</span></span>
        </td>
        <td *ngIf="showActivationCodeColumn">
          <span class="ellipsis-cell code-cell" [matTooltip]="act.code || ''" [matTooltipDisabled]="!shouldShowTooltip(act.code, 26)">{{
            act.code }}</span>
        </td>
        <td *ngIf="showComments">
          <span class="ellipsis-cell comment-cell" [matTooltip]="act.comment || ''"
            [matTooltipDisabled]="!act.comment">{{ act.comment }}</span>
        </td>
        <td class="nowrap-cell">{{ act.timestamp | date: "dd MMMM yyyy" }}</td>
        <td *ngIf="rental" class="nowrap-cell">{{ act.expiry | date: "dd MMMM yyyy" }}</td>
        <td class="table-actions-cell" *ngIf="showActionColumn">
          <button mat-icon-button color="primary" type="button" [id]="'copy-activation-code-' + i" *ngIf="canCopyActivationKey(act)"
            (click)="copyActivationCode(act.code)"
            matTooltip="Copy activation key">
            <mat-icon>key</mat-icon>
          </button>
          <button mat-icon-button color="primary" type="button" [id]="'copy-license-command-' + i" *ngIf="canCopyLicenseCommand(act)"
            (click)="copyLicenseCommand(act)" matTooltip="Copy license command">
            <mat-icon>terminal</mat-icon>
          </button>
        </td>
        <td *ngIf="showSurrender" class="table-actions-cell">
          <mat-checkbox [id]="'surrender-activation-' + i" [(ngModel)]="act.selected" [ngModelOptions]="{standalone: true}"></mat-checkbox>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="fh-table table-responsive" *ngIf="showRenew && !loading">
  <div class="notice">
    <div class="notice-body">Duplicate activations have been removed from this list. The timestamps show the earliest
      activation with the latest expiry.</div>
  </div>
  <div class="notice notice-error" *ngIf="error">
    <div class="notice-body">
      Failed to renew license<span *ngIf="selectedCount > 1">s</span>.<br>
      {{ error?.description }}
    </div>
  </div>
  <table class="table table-striped table-hover activation-table">
    <colgroup>
      <col class="col-checkbox">
      <col class="col-hostname">
      <col class="col-type">
      <col *ngIf="showActivationCodes" class="col-code">
      <col class="col-date">
      <col class="col-date">
      <col class="col-actions">
    </colgroup>
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-renew-hostname" (click)="sortBy('hostname')">Hostname
            <mat-icon>{{ getSortIcon('hostname') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-renew-type" (click)="sortBy('type')">Type <mat-icon>{{
              getSortIcon('type') }}</mat-icon></button></th>
        <th *ngIf="showActivationCodes">License Key</th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-renew-obtained" (click)="sortBy('obtained')">First Obtained
            <mat-icon>{{ getSortIcon('obtained') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-renew-expiry" (click)="sortBy('expiry')">Expired
            <mat-icon>{{ getSortIcon('expiry') }}</mat-icon></button></th>
        <th class="table-actions-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="displayedActivations.length == 0">
        <td colspan="7" class="table-empty-state">You have no expired licenses to renew.</td>
      </tr>
      <tr *ngFor="let act of displayedActivations; let i = index">
        <td>
          <mat-checkbox [id]="'renew-activation-' + i" [(ngModel)]="act.selected" [ngModelOptions]="{standalone: true}"></mat-checkbox>
        </td>
        <td>
          <span class="ellipsis-cell hostname-cell" [matTooltip]="act.hostname || ''"
            [matTooltipDisabled]="!shouldShowTooltip(act.hostname, 28)">{{ act.hostname }}</span>
        </td>
        <td class="nowrap-cell text-capitalize">
          <span *ngIf="act.activationType != 'TOKEN'">{{ getActivationTypeLabel(act) }}</span>
          <span *ngIf="act.activationType == 'TOKEN'">{{ act.count }} token<span *ngIf=" act.count == 0||act.count > 1">s</span></span>
        </td>
        <td *ngIf="showActivationCodes">
          <span class="ellipsis-cell code-cell" [matTooltip]="act.code || ''" [matTooltipDisabled]="!shouldShowTooltip(act.code, 26)">{{
            act.code }}</span>
        </td>
        <td class="nowrap-cell">{{ act.timestamp | date: "dd MMMM yyyy" }}</td>
        <td class="nowrap-cell">{{ act.expiry | date: "dd MMMM yyyy" }}</td>
        <td class="table-actions-cell">
          <button mat-icon-button color="primary" type="button" [id]="'copy-renew-activation-code-' + i"
            (click)="copyActivationCode(act.code)" matTooltip="Copy activation key">
            <mat-icon>key</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #confirmModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="confirm-renew-dialog-title" class="dialog-title">
      <span class="title-text">Confirm Renewal</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="confirm-renew-dismiss-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>
      Are you sure you want to renew {{selectedCount}} activations?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" type="button" id="confirm-renew-cancel-button" (click)="closeDialog()">
        Cancel
      </button>
      <button mat-raised-button color="primary" type="button" id="confirm-renew-confirm-button" (click)="confirmRenewLicenses()"
        [disabled]="renewing">
        <mat-spinner *ngIf="renewing" diameter="20" mode="indeterminate"></mat-spinner>
        {{ renewing ? 'Renewing' : 'Confirm' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #activationModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="activation-success-dialog-title" class="dialog-title">
      <span class="title-text">Activation Successful</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="activation-success-dismiss-button"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <div class="notice mb-3">
        <div class="notice-body">Successfully renewed license(s).</div>
      </div>

      <table class="table table-sm table-bordered modal-result-table">
        <thead>
          <tr>
            <th>Hostname</th>
            <th *ngIf="showActivationCodes">Activation Key</th>
            <th *ngIf="showActivationCodes">Licensing Command</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of activationResponse;">
            <td class="modal-hostname-cell">{{ entry.hostname }}</td>
            <td *ngIf="showActivationCodes"><code class="modal-key-cell">{{ entry.code }}</code></td>
            <td *ngIf="showActivationCodes">
              <div class="license-command-cell">
                <code>{{ getActivationResponseLicenseCommand(entry) }}</code>
                <button mat-icon-button color="primary" type="button" (click)="copyActivationResponseLicenseCommand(entry)"
                  matTooltip="Copy license command">
                  <mat-icon>terminal</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" type="button" id="activation-success-copy-button" (click)="copyActivationDetails()">Copy
        Details</button>
      <button mat-raised-button color="primary" type="button" id="activation-success-close-button" (click)="closeDialog()">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
